var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHonduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95424 31.0457 -6.10352e-05 20 -6.10352e-05C8.95431 -6.10352e-05 0 8.95424 0 19.9999C0 31.0456 8.95431 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C27.9291 39.9999 34.7804 35.3854 38.0154 28.6955H1.9845C5.2195 35.3854 12.0707 39.9999 20 39.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -0.000183105C12.0707 -0.000183105 5.2195 4.61427 1.9845 11.3042H38.0154C34.7804 4.61427 27.9291 -0.000183105 20 -0.000183105V-0.000183105Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3082 13.0433L12.9557 15.0362H15.051L13.3559 16.2677L14.0035 18.2606L12.3082 17.029L10.6128 18.2606L11.2604 16.2677L9.56519 15.0362H11.6606L12.3082 13.0433Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3082 21.739L12.9557 23.7319H15.051L13.3559 24.9635L14.0035 26.9563L12.3082 25.7247L10.6128 26.9563L11.2604 24.9635L9.56519 23.7319H11.6606L12.3082 21.739Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6917 13.0433L28.3393 15.0362H30.4347L28.7394 16.2677L29.387 18.2606L27.6917 17.029L25.9964 18.2606L26.644 16.2677L24.9487 15.0362H27.0442L27.6917 13.0433Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6917 21.739L28.3393 23.7319H30.4347L28.7394 24.9635L29.387 26.9563L27.6917 25.7247L25.9964 26.9563L26.644 24.9635L24.9487 23.7319H27.0442L27.6917 21.739Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 17.3911L20.6475 19.3841H22.7429L21.0477 20.6156L21.6952 22.6085L19.9999 21.3768L18.3046 22.6085L18.9522 20.6156L17.257 19.3841H19.3524L19.9999 17.3911Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonduras);
export default __webpack_public_path__ + "static/media/honduras.a3b9d4e2997d6a7c57e77cad7b16e2f1.svg";
export { ForwardRef as ReactComponent };